export default "__VITE_ASSET__CTs7HbZI__"